import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '../../utils';
import styles from './SelectAll.module.css';
const SelectAll = ({ className, selectAllText, areAnySelected, toggleSelectAll }) => {
    return (_jsx("div", Object.assign({ className: classNames(className, styles.root) }, { children: _jsx("span", Object.assign({ tabIndex: 0, onKeyPress: toggleSelectAll, role: "button", onClick: toggleSelectAll }, { children: selectAllText || (areAnySelected ? 'Deselect All' : 'Select All') }), void 0) }), void 0));
};
export default SelectAll;
